export const Pageheader = {
  Students: "Students",
  StudentDetails: "Student details",

  ParentDetails: "Parent details",

  ResultDetails: "Result details",

  SchoolPrices: "School prices",
};
